import { API_URL } from '../constants';
import { apiRequest } from '../utils/api';

export interface Notification {
  id: string;
  userId: string;
  actorId: string;
  type: 'like' | 'comment' | 'subscription' | 'post';
  entityId: string;
  entityType: 'post' | 'comment' | 'subscription';
  message: string;
  isRead: boolean;
  createdAt: string;
  updatedAt: string;
  actor: {
    id: string;
    username?: string;
    email?: string;
    avatar?: string;
  };
}

export interface NotificationResponse {
  notifications: Notification[];
  pagination: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };
}

class NotificationService {

  async getNotifications(page: number = 1, limit: number = 20, unreadOnly: boolean = false): Promise<NotificationResponse> {
    return apiRequest(`${API_URL}/api/notifications?page=${page}&limit=${limit}&unreadOnly=${unreadOnly}`);
  }

  async getUnreadCount(): Promise<{ count: number }> {
    return apiRequest(`${API_URL}/api/notifications/unread-count`);
  }

  async markAsRead(notificationId: string): Promise<void> {
    await apiRequest(`${API_URL}/api/notifications/${notificationId}/read`, {
      method: 'PATCH',
    });
  }

  async markAllAsRead(): Promise<void> {
    await apiRequest(`${API_URL}/api/notifications/mark-all-read`, {
      method: 'PATCH',
    });
  }

  async deleteNotification(notificationId: string): Promise<void> {
    await apiRequest(`${API_URL}/api/notifications/${notificationId}`, {
      method: 'DELETE',
    });
  }
}
const notificationService = new NotificationService();
export default notificationService;
